<template>
  <v-tooltip right>
    <v-fab-transition slot="activator">
      <v-btn
        :color="active ? 'accent' : 'primary'"
        small
        fab
        :disabled="disabled"
        @click="onClick"
      >
        <v-icon v-if="active">
          attach_money
        </v-icon>

        <v-icon v-else>
          money_off
        </v-icon>
      </v-btn>
    </v-fab-transition>
    <span v-if="disabled">{{ $t('message.editor.preview.additionalModes.disabledPartnerMode') }}</span>
    <span v-else-if="active">{{ $t('message.editor.preview.additionalModes.cancelPartnerMode') }}</span>
    <span v-else>{{ $t('message.editor.preview.additionalModes.usePartnerMode') }}</span>
  </v-tooltip>
</template>

<script>
export default {
  inject: {
    reloadPreview: {
      default: () => () => {},
    },
  },
  props: {
    active: Boolean,
    disabled: Boolean,
  },
  methods: {
    onClick() {
      this.$emit('update:active', !this.active);
      this.reloadPreview({ partner: !this.active ? 1 : 0 });
    },
  },
};
</script>
